import dayjs from "dayjs";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import {
  isActiveISOSettingSelector, // [crm-iso]
  userSelector,
} from "appredux/selectors";

const useMeetingReminderHandler = () => {
  const currentUser = useSelector(userSelector);
  const isActiveISO = useSelector(isActiveISOSettingSelector); // [crm-iso]
  const [activeReminders, setActiveReminders] = useState([]);

  const meetingReminderHandler = useCallback(
    (payload) => {
      // [crm-iso] Agen terpengaruh tidak menerima notifikasi meeting schedule.
      // TEARDOWN: hapus baris di bawah + isActiveISO dari deps.
      if (isActiveISO) return;
      if (payload.schedule_admin_agent_id !== currentUser.id) return;

      const meetingTime = dayjs(
        `${payload.date} ${payload.start_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      if (meetingTime.isBefore(dayjs())) return;

      setActiveReminders((prev) => {
        const alreadyExists = prev.some((r) => r.schedule_id === payload.schedule_id);
        if (alreadyExists) return prev;
        return [...prev, payload];
      });
    },
    [currentUser.id, isActiveISO] // [crm-iso] deps: isActiveISO
  );

  const closeReminder = useCallback((scheduleId) => {
    setActiveReminders((prev) => prev.filter((r) => r.schedule_id !== scheduleId));
  }, []);

  return { meetingReminderHandler, activeReminders, closeReminder };
};

export default useMeetingReminderHandler;
